if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    static BROWSE_KEYS = new Set([
      'ArrowUp',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End',
      'PageUp',
      'PageDown',
    ]);

    #browsing = false;
    #submitted = '';

    connectedCallback() {
      const select = this.querySelector('select');
      if (!select?.form) return;

      const value = this.querySelector('.loc__value');
      this.#submitted = select.value;

      select.addEventListener('pointerdown', () => {
        this.toggleAttribute('data-pointer', true);
      });

      select.addEventListener('keydown', (event) => {
        this.toggleAttribute('data-pointer', false);

        if (event.key === 'Enter') {
          event.preventDefault();
          this.#submit(select);
          return;
        }

        const typed = event.key.length === 1 && event.key !== ' ';
        if (!typed && !LocalizationForm.BROWSE_KEYS.has(event.key)) return;

        this.#browsing = true;
        setTimeout(() => {
          this.#browsing = false;
        });
      });

      select.addEventListener('change', () => {
        if (value) value.textContent = select.options[select.selectedIndex].text;
        if (!this.#browsing) this.#submit(select);
      });

      select.addEventListener('blur', () => {
        this.toggleAttribute('data-pointer', false);
        if (select.value === this.#submitted) return;
        select.value = this.#submitted;
        if (value) value.textContent = select.options[select.selectedIndex].text;
      });
    }

    #submit(select) {
      if (select.value === this.#submitted) return;

      this.#submitted = select.value;
      select.form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
